import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import Transition from '@ember/routing/-private/transition';

export default class WorkspaceSubscriptionCenterSettings extends Route {
  @service analytics!: AnalyticsService;

  setupController(controller: any, model: any, transition: Transition) {
    super.setupController(controller, model, transition);
    // routes from where we do not want to track a transition from
    let editorRoutes = ['workspace-settings.subscription_center.branding_edit'];
    if (!editorRoutes.includes(transition.from?.name ?? '')) {
      this.analytics.track('subscription_center', 'settings_page_viewed');
    }
  }
}
